<template>
  <Loader :loading="rootScope.loading"/>
  <router-view/>
</template>

<style>

</style>

<script setup>

import Loader from "@/components/Loader/LoaderComponent.vue";
import {inject,onMounted} from "vue";

const rootScope = inject('rootScope');

onMounted(() => {
  const link = document.createElement('link');
  link.rel = 'icon';
  link.href = '/favicon.ico'; // Cambia según tu favicon
  document.head.appendChild(link);
});

</script>
